const LOCAL_STORAGE_TYPES = {
    restart: 'restart',
    isGettingStart: 'isGettingStart',
    autoRefreshTimeout: 'autoRefreshTimeout',
    dontShowConfirmForTranscription: 'transcriptionConfirm',
}

export {
    LOCAL_STORAGE_TYPES,
}
